<template>
<div class="header-of-pages">
  <div v-bind:class="css">
    <!-- Title -->
    <div class="col-md-12">
      <div class="title">
        <h1>{{ headerName }}</h1>
      </div>

      <a v-if="showBtn" class="btn-back" v-bind:href="btnRoute">{{ btnName }}</a>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'page-header',
  props: ['headerName', 'showBtn', 'btnName', 'btnRoute', 'css'],
  beforeMount() {
    // console.log(this.headerName);
    // console.log(this.showBtn);
    // console.log(this.btnName);
    // console.log(this.btnRoute);
  }
}
</script>

<style lang="scss">
// Header from pages
.header-of-pages {
  max-height: 74px;
  height: 74px;
  border-bottom: 1px solid #00000047;
  background: #FFFFFF;
  padding-bottom: 12px;
  margin-bottom: 20px;

  .title {
    display: inline-block;
    float: left;
    padding: 22px 0;

    h1 {
      color: #201e1e;
      font-size: 24px;
      font-weight: 400;
      margin: 0;
      padding: 0;

      @media only screen and (max-device-width: 414px) {
        font-size: 20px;
      }
    }

    @media only screen and (max-device-width: 414px) {
      padding: 24px 0;
    }
  }

  .btn-new {
    padding: 28px 0;
    margin-left: 30px;

    a {
      color: #FFFFFF;
      text-decoration: none;
      background: #3598dc;
      margin-left: 30px;
      padding: 8px 20px;
      border-radius: 4px !important;

      &:hover,
      &:active,
      &:focus {
        background-color: #0F77AE;
      }
    }

    i {
      margin-right: 5px;
    }

  }

  .btn-back {
    float: right;
    margin-top: 22px;
    background: #3598dc;
    color: #fff;
    padding: 3px 20px 1px;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 25px;
    border-radius: 4px !important;

    &:hover,
    &:active,
    &:focus {
      background-color: #0F77AE;
      text-decoration: none;
    }
  }

  @media only screen and (max-device-width: 414px) {
    border-top: 1px solid #00000047;
    max-height: none;
    height: auto;
    padding-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/default/pageHeader.vue